const Sponsorship = () => {
    return (
        <div>
            <h1>Sponsorship</h1>
        </div>
    );
};

export default Sponsorship;
